export default class CheckInItem {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.checkInId = apiResponse.checkInId;
        this.accommodationUnitId = apiResponse.accommodationUnitId;
    }

    clone() {
        const checkInItem = new CheckInItem({});
        checkInItem.id = this.id;
        checkInItem.checkInId = this.checkInId;
        checkInItem.accommodationUnitId = this.accommodationUnitId;
        return checkInItem;
    }

}